import { isValidationObject } from './isValidationObject';
/**
 * Validates a rule and returns an error message if validation fails.
 *
 * @param {T | Validation<T>} ruleValue - The rule value or a Validation object.
 * @param {string} value - The value to be validated.
 * @param {(rule: T, value: string) => boolean} validator - The function to validate the value.
 * @param {string} defaultMessage - Default error message if validation fails.
 * @returns {string | null} - Error message if validation fails, null otherwise.
 */
export const validateRule = (ruleValue, value, validator, defaultMessage) => {
    if (isValidationObject(ruleValue)) {
        return validator(ruleValue.value, value) ? null : ruleValue.message;
    }
    else {
        return validator(ruleValue, value) ? null : defaultMessage;
    }
};
